import React from 'react';
import styled from 'styled-components';
import { localizable } from 'components/Localization';

const ContinueButton = styled.a`
  margin-top: 3em;
  display: block;
  text-align: center;
  color: ${(props) => props.theme.palette.themePrimary};
  font-size: 1.5em;
  cursor: pointer;

  i {
    margin-left: 0.2em;
  }
`;

export default localizable('SaleWizardResult')(({ store, t, theme }) => (
  <div>
    <h1>{t('Confirmation')}</h1>

    <p>{t('Successful')}</p>

    <ContinueButton
      theme={theme}
      onClick={() =>
        (window.location.href = `/dashboard/${store.actionStore.saleId}`)
      }
    >
      {t('Continue to the duplicated sale')}
      <i className="ms-Icon ms-Icon--NavigateForward" aria-hidden="true"></i>
    </ContinueButton>
  </div>
));



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Duplicate/Results.jsx